import { render, staticRenderFns } from "./MealPlanCollectionView.vue?vue&type=template&id=1fc63cca&scoped=true"
import script from "./MealPlanCollectionView.vue?vue&type=script&lang=js"
export * from "./MealPlanCollectionView.vue?vue&type=script&lang=js"
import style0 from "./MealPlanCollectionView.vue?vue&type=style&index=0&id=1fc63cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc63cca",
  null
  
)

export default component.exports